import DateFnsUtils from "@date-io/date-fns";
import {
  Checkbox,
  Fab,
  Grid,
  Icon,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getData } from "../../../api/apiCaller";
import Autocomplete from "../../../components/Autocomplete";
import { getListPhoneNumber } from "../../../redux/cloudPBX/phoneNumber";

const OPTIONS_SIZE = 20;

const SearchBar = ({ searchForm, onClickExport }) => {
  const dispatch = useDispatch();
  const listPhoneNumber = useSelector(
    (state) => state.phoneNumber.phoneNumbers
  );

  const [subOrgs, setSubOrgs] = useState([]);

  const getProvice = async (fullname, limit, citycode, districtcode) => {
    const where = {
      ...(fullname && { fullname: { like: fullname, options: "i" } }),
      ...(citycode && !districtcode && { citycode }),
      ...(districtcode && { districtcode }),
    };
    const { data } = await getData("/vnpost/province", {
      filter: { where, limit },
    });
    setSubOrgs(data);
  };

  useEffect(() => {
    getProvice("", OPTIONS_SIZE);
    dispatch(getListPhoneNumber());
  }, []);

  return (
    <form onSubmit={searchForm.handleSubmit}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={24}>
          <Grid item xs={12} md={3}>
            <Autocomplete
              options={subOrgs}
              value={searchForm.values.subOrg}
              onChangeValue={(option) => {
                searchForm.setFieldValue("subOrg", option);
              }}
              onTextChange={(text) =>
                getProvice(
                  text,
                  OPTIONS_SIZE,
                  searchForm.values.city?.code,
                  searchForm.values.district?.code
                )
              }
              getLabel={(option) => option?.name || ""}
              onScrollBottom={(text, currentLength) => {
                getProvice(
                  text,
                  currentLength + OPTIONS_SIZE,
                  searchForm.values.city?.code,
                  searchForm.values.district?.code
                );
              }}
              label="Bưu cục"
              debounceTime={300}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <InlineDatePicker
              label="Chọn tháng"
              variant="outlined"
              maxDate={new Date()}
              format="MM-yyyy"
              value={searchForm.values.month}
              views={["year", "month"]}
              onChange={(date) => searchForm.setFieldValue("month", date)}
              validators={["required"]}
              fullWidth
              keyboard
              invalidDateMessage="Định dạng tháng không đúng"
              maxDateMessage="Tháng lớn hơn tháng tối đa"
              minDateMessage="Tháng nhỏ hơn tháng tối thiểu"
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              value={searchForm.values.phoneNumbers}
              SelectProps={{
                multiple: true,
                renderValue: (value) =>
                  value.some((item) => item === "all")
                    ? "Tất cả"
                    : value.join(", "),
              }}
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  const indexOfAll = e.target.value.indexOf("all");
                  if (indexOfAll === -1) {
                    searchForm.setFieldValue("phoneNumbers", e.target.value);
                  }
                  if (indexOfAll === 0) {
                    searchForm.setFieldValue(
                      "phoneNumbers",
                      e.target.value.filter((item) => item !== "all")
                    );
                  }
                  if (indexOfAll > 0) {
                    searchForm.setFieldValue("phoneNumbers", ["all"]);
                  }
                } else {
                  searchForm.setFieldValue("phoneNumbers", ["all"]);
                }
              }}
              select
              label="Đầu số"
              variant="outlined"
              fullWidth>
              <MenuItem value="all">
                <Checkbox
                  checked={searchForm.values.phoneNumbers.some(
                    (phone) => phone === "all"
                  )}
                />
                Tất cả
              </MenuItem>
              {listPhoneNumber?.map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  <Checkbox
                    checked={searchForm.values.phoneNumbers.some(
                      (phone) => phone === item.id
                    )}
                  />
                  {item.id}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              {...searchForm.getFieldProps("callType")}
              select
              label="Loại cuộc gọi"
              variant="outlined"
              fullWidth>
              <MenuItem value="all">Tất cả</MenuItem>
              <MenuItem value="innet">Nội mạng</MenuItem>
              <MenuItem value="outnet">Ngoại mạng</MenuItem>
            </TextField>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab color="primary" style={{ marginLeft: "15px" }} type="submit">
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                style={{ marginLeft: "15px" }}
                onClick={onClickExport}>
                <Icon>save_alt</Icon>
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </form>
  );
};

export default SearchBar;
